/**
 * 季节价格计算器．用于私家团和主题游产品
 *
 */
(function ($) {

    /**
     * Plugin to calculate the price
     *
     * @param options
     * @returns {jQuery}
     */
    $.fn.seasonPriceCalculator = function (options) {

        /**
         * The quantity of adult
         *
         * @type {number}
         */
        var adultQuantity = 0;


        /**
         *
         * @type {number}
         */
        var memberCount = 0;

        /**
         *
         * @type {null}
         */
        var startDatum = null;


        /**
         * The adult quantity field
         *
         * @type {*}
         */
        var adultField = $('input#adults');


        /**
         * Price filed
         *
         * @type {*|HTMLElement}
         */
        var priceSummeContainer = $("#priceSumme");


        /**
         *
         * @type {*}
         */
        var startDatumField = $("#startDatum");

        /**
         *
         * @type {null}
         */
        var matchedColum = null;
        //var diffMatchCollmn = null;

        /**
         *
         * @type {null}
         */
        var matchedRow = null;



        var diffMatchRow = null;

        /**
         *
         * @type {null}
         */
        var matchedCell = null;



        var diffMatchCell = null;

        var failedReason = "";


        var defaults = {
            debug : true,
            seasonPrice : null
        };

        /**
         * Merge the options with default options
         *
         *
         */
        var settings = $.extend(
            {},
            defaults,
            options
        );

        /**
         * Debug output in console
         *
         * @param msg
         */
        var clog = function (msg) {
            if (settings.debug == true) {
                console.log(msg);
            }
        };


        /**
         * 更新人数
         */
        var updateQuantity = function () {
            adultQuantity = parseInt(adultField.val());
            $("#adultCount").html(adultQuantity);
        };

        /**
         * Update the start datum
         */
        var updateStartDatum = function () {
            var tmp = startDatumField.val();
            startDatum = new Date(tmp);
        };


        /**
         *
         * "columns": [
                 {
                "id": 7,
                "master_id": 5,
                "name": "11\u6708-4\u6708",
                "start_datum": "2019-11-01",
                "end_datum": "2020-04-30"
              },
            ...
         */
        var queryColumn = function () {
            matchedColum = null; // init
            $('#colName').html("");
            $.each(settings.seasonPrice.columns, function (idx, col) {
                clog("" + col.name + ", " + col.start_datum + " - " + col.end_datum);
                var seasonStart = new Date(col.start_datum);
                var seasonEnd = new Date(col.end_datum);
                if ((startDatum.getTime() >= seasonStart.getTime())
                    && (startDatum.getTime() <= seasonEnd.getTime())
                ) {
                    // found
                    clog("Found!");
                    matchedColum = col ;
                    $("#colName").html(col.name);
                    failedReason = "";
                    return false;
                }
            })
            failedReason = "日期超出范围";
            return;
        };

        /**
         *
         *
         * "rows": [
             {
                "id": 22,
                "master_id": 5,
                "name": "2\u4eba",
                "value": "2"
              },
         *
         */
        var queryRow = function () {
            clog("queryRow() called.");
            matchedRow = null;
            failedReason = "";
            $.each(settings.seasonPrice.rows, function (idx, row) {
                clog(row.name + ", " + row.value);
                if (row.value != 0 && row.value == (adultQuantity)) {
                    clog("found");
                    matchedRow = row;
                } else if(row.name == "单房差"){
                    clog("found 单房差");
                    diffMatchRow = row;
                }
            });
            return;
        };


        var queryCell = function () {
            matchedCell = null;
            $.each(settings.seasonPrice.cells, function (idx, cell) {
                if (cell.column_id == matchedColum.id && cell.row_id == diffMatchRow.id) {
                    diffMatchCell = cell;
                }
            });
            $.each(settings.seasonPrice.cells, function (idx, cell) {
                if (cell.column_id == matchedColum.id && cell.row_id == matchedRow.id) {
                    matchedCell = cell;
                    failedReason = "";
                    return false;
                } else {
                    failedReason = "超出范围";
                }
            });
            return;
        };

        /**
         * 计算价格
         * @returns {boolean}
         */
        var caculatePrice = function () {
            clog("caculatePrice() called");
            queryColumn();
            if (matchedColum == null) {
                return false;
            }
            queryRow();
            if (matchedRow == null) {
                return false;
            }
            queryCell();
            if (matchedCell == null) {
                return false;
            }
            return true;
        };


        /**
         * 更新价格
         *
         */
        var update = function () {
            failedReason = "";// init
            updateStartDatum();
            updateQuantity();
            memberCount = adultQuantity;
            if(!caculatePrice()) {
                matchedRow = null;
                matchedColum = null;
                matchedCell = null;
                priceSummeContainer.html("N/A");
                $("#unitPrice").html("N/A");
                // $('#unitDifference').html('N/A');
                clog(failedReason);
                return false;
            }
            var unitPrice = parseFloat(matchedCell.value).toFixed(2);
            var currency = matchedCell.currency;
            var currencySympol = "";
            if (currency === "EUR") {
                currencySympol = "€";
            } else {
                currencySympol = currency;
            }
            $("#unitPrice").html(unitPrice + " " +currencySympol);

            // var diffPrice = parseFloat(diffMatchCell.value).toFixed(2);
            // $('#unitDifference').html(diffPrice);
            // 总价格＝单价*人数，取２位小数
            var totalPrice = parseFloat(unitPrice * memberCount).toFixed(2);
            priceSummeContainer.html(totalPrice + " " +currencySympol);
        };

        /**
         *
         */
        var initEvents = function () {
            clog("initEvents() called.");
            /**
             * Do not use "change" event! It fire 3 times. Use "changeDate" event.
             */
            $("#startDatum").on("changeDate", update);
            adultField.on("change", update);
            $(".button_inc").on("click", update);
        };


        var init = function () {
            initEvents();
        };



        init();


        return this;
    }

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/jquery.seasonPriceCalculator.js